module.exports = __webpack_public_path__ + "static/models/speedworld_road.d30a951.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/speedworld_road.json
// module id = 549
// module chunks = 1